import { render, staticRenderFns } from "./InvestorArticleView.vue?vue&type=template&id=0f06207c"
import script from "./InvestorArticleView.vue?vue&type=script&lang=js"
export * from "./InvestorArticleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports